import { alpha, Box } from "@mui/material";

export type FernieCardAccent = "error" | "neutral" | "primary" | "success";

interface FernieCardShellProps {
	accent: FernieCardAccent;
	branded?: boolean;
	children: React.ReactNode;
	tinted?: boolean;
}

const FernieCardShell = ({ accent, branded = false, children, tinted = false }: FernieCardShellProps) => (
	<Box
		sx={
			branded
				? {
						backgroundColor: "background.paper",
						border: "1px solid",
						borderColor: "divider",
						borderLeft: tinted && accent !== "neutral" ? "3px solid" : "1px solid",
						borderLeftColor: (theme) =>
							tinted && accent !== "neutral" ? alpha(theme.palette[accent].main, 0.55) : theme.palette.divider,
						borderRadius: "16px",
						boxShadow: (theme) => `0 1px 3px ${alpha(theme.palette.common.black, 0.06)}`,
						mt: 1.5,
						overflow: "hidden"
					}
				: {
						backgroundColor: (theme) =>
							tinted && accent !== "neutral" ? alpha(theme.palette[accent].main, 0.06) : "transparent",
						border: "1px solid",
						borderColor: (theme) =>
							accent === "neutral" ? theme.palette.divider : alpha(theme.palette[accent].main, 0.35),
						borderRadius: "12px",
						mt: 1.5,
						overflow: "hidden"
					}
		}
	>
		{children}
	</Box>
);

export default FernieCardShell;
